const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Mehmet Kaya',
      role: 'Ev Sahibi, Bornova',
      text: 'Mutfak tadilatımızı çok başarılı bir şekilde tamamladılar. Kaliteli malzeme kullanımı ve titiz işçilik. Kesinlikle tavsiye ederim.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Zeynep Demir',
      role: 'Cafe Sahibi, Alsancak',
      text: 'Cafemizin komple tadilatını yaptırdık. Hem tasarım hem uygulama mükemmeldi. Müşterilerimizden çok olumlu geri dönüşler alıyoruz.',
      rating: 5,
    },
    {
      id: 3,
      name: 'Ahmet Yılmaz',
      role: 'Ev Sahibi, Karşıyaka',
      text: 'Banyo tadilatı için çalıştık. Zamanında teslim, temiz işçilik ve uygun fiyat. Çok memnun kaldık.',
      rating: 5,
    },
  ];

  return (
    <section className="py-24 bg-cream">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-beige/20 rounded-full mb-6">
            <span className="text-wood-dark font-medium">Müşteri Yorumları</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-wood-dark mb-4">
            Müşterilerimiz Ne Diyor?
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Projelerimizi tamamlayan müşterilerimizin deneyimlerini okuyun
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300"
            >
              {/* Rating Stars */}
              <div className="flex space-x-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="pt-6 border-t border-gray-100">
                <div className="font-semibold text-wood-dark mb-1">
                  {testimonial.name}
                </div>
                <div className="text-sm text-gray-500">{testimonial.role}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/referanslar"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-wood-dark hover:bg-wood text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span>Tüm Referansları Görüntüle</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
